import { TextLink } from '@app/components/core/link/TextLink'
import { Image } from '@app/components/core/image/Image'
import { Text } from '@app/components/core/typography/Text'
import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { type Style } from 'inlines'
import { type ReactNode } from 'react'

export type FollowingEmptyStateProps = {
  title: ReactNode
  message: ReactNode
  imageSrc: string
  imageAlt: string
  discoverHref: string
  discoverLabel: ReactNode
  style?: Style
}

export const FollowingEmptyState = ({
  title,
  message,
  imageSrc,
  imageAlt,
  discoverHref,
  discoverLabel,
  style,
}: FollowingEmptyStateProps) => (
  <Column alignItems="stretch" gap="1rem" style={style}>
    <Title.H4>{title}</Title.H4>
    <Row alignItems="center" gap="1.5rem">
      <Image src={imageSrc} alt={imageAlt} style={{ width: '9rem' }} />
      <Column gap="0.5rem">
        <Text.Medium color="var(--shades-blue-400)">{message}</Text.Medium>
        <TextLink
          to={discoverHref}
          hasIcon={true}
          iconPosition="right"
          containerStyle={{
            textDecoration: 'none',
          }}
        >
          {discoverLabel}
        </TextLink>
      </Column>
    </Row>
  </Column>
)
